import EnumBase from './Base';

export default function metadatumCompetenceEnum(){
  return new EnumBase([
    { id: 'record', name: 'Registro' },
    { id: 'record_items', name: 'Registro com itens' }
  ]);
}
